
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

function Program({ career }) {
  const image = require(`../../assets/img/${career.id}.jpg`);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial={{ y: 30, opacity: 0 }}
      animate={isInView ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      whileHover={{ scale: 1.04, boxShadow: "0 12px 32px rgba(0,0,0,0.18)" }}
      className="bg-white rounded shadow-lg overflow-hidden border border-gray-200 w-100"
      style={{ cursor: "pointer", display: "flex", flexDirection: "column" }}
      onClick={() => window.location.href = `/carreras/${career.id}`}
    >
      <div
        style={{
          height: "300px",
          flexShrink: 0,
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        role="img"
        aria-label={career.name}
      />
      <div className="p-4">
        <h3 className="font-bold text-lg text-blue-900">{career.name}</h3>
        <p className="text-gray-600 mt-2">{career.homeOverview}</p>
      </div>
    </motion.div>
  );
}

export default Program;
